import { makeStyles } from '@material-ui/core/styles';

import theme from '../../MaterialUi/MaterialUi';

const useStyles = makeStyles({
	card: {
		height: '100%',
		borderRadius: '7px',
		'&:hover': {
			backgroundColor: '#f0f0f0',
		},
	},
	cardMedia: {
		height: 0,
		paddingTop: '56.25%',
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
	},
	cardTitlePrice: {
		color: theme.palette.primary.main,
		textAlign: 'center',
	},
	priceButtonContainer: {
		display: 'flex',
		justifyContent: 'space-evenly',
	},
	cardButton: {
		backgroundColor: theme.palette.primary.dark,
		'&:hover': {
			backgroundColor: theme.palette.primary.light,
		},
	},
});

export default useStyles;
